import { useAppStore } from '@/store'
import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'
// const { getReferenceConstantMap } = useAppStore()

export const paymentRoutes: CustomRouteRecordRaw = {
  path: 'payment',
  name: 'payment',
  component: EmptyLayout,
  redirect: { name: 'walletCompany' },
  meta: {
    title: '资产中心',
    iconfont: 'icon-database',
    requiredPermission: 'payment',
  },
  children: [
    {
      path: 'wallet-company',
      name: 'walletCompany',
      component: () => import('@/views/payment/wallet-company.vue'),
      meta: {
        title: '企业钱包',
        requiredPermission: 'payment.wallet.company',
      },
    },
    {
      path: 'wallet-recharge-log',
      name: 'walletRechargeLog',
      component: () => import('@/views/payment/wallet-log.vue'),
      meta: {
        title: '充值流水',
        requiredPermission: 'payment.wallet.recharge.log'
      },
      props: {
        type: 2
      }
    },
    {
      path: 'wallet-transaction-log',
      name: 'walletTransactionLog',
      component: () => import('@/views/payment/wallet-log.vue'),
      meta: {
        title: '交易流水',
        requiredPermission: 'payment.wallet.transaction.log',
      },
      props: {
        type: 'all'
      }
    },
    {
      path: 'order-cost-log',
      name: 'orderCostLog',
      component: () => import('@/views/payment/order-cost-log.vue'),
      meta: {
        title: '成本核算',
        requiredPermission: 'payment.order.cost.log',
      }
    }
    // {
    //   path: 'wallet-person',
    //   name: 'walletPerson',
    //   component: () => import('@/views/payment/wallet-person.vue'),
    //   meta: {
    //     title: '个人充值流水',
    //   },
    // },
  ],
}
